<div data-testid="seasonal-load" class="seasonal-load">
  <header class="seasonal-load__header">
    <div class="seasonal-load__titles">
      <h4 class="seasonal-load__title">{{ title }}</h4>
      <p data-testid="seasonal-description" class="seasonal-load__description">{{ description }}</p>
      <p *ngIf="peakText" data-testid="seasonal-peak" class="seasonal-load__peak">{{ peakText }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="seasonal-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && !available" data-testid="seasonal-empty" icon="fa-regular fa-calendar"
                             [title]="'Not enough history yet'"></app-admin-dashboard-empty>
  <div *ngIf="loaded && available" #chart data-testid="seasonal-chart" class="seasonal-load__chart"></div>
  <p *ngIf="backfillNote" data-testid="seasonal-backfill-note" class="seasonal-load__note">{{ backfillNote }}</p>
  <div *ngIf="!loaded" class="seasonal-load__chart"></div>
</div>
